import React from 'react';

const HtmlViewer = ({ url }) => {
  return (
    <iframe style={{height:'100vh', width:'100%'}}  src={url}/>
  );
};

export default HtmlViewer;